import { Fragment, useId, useState } from 'react';
import type { PrehistoryCredit } from '../api/model';
import { formatDecimal } from '../lib/decimal';
import { HelpButton, HelpText } from './Help';
import { Val } from './Val';

/**
 * D51/D53: the open-loan figure is the recorded borrow outstanding; repays marked as pre-history do not reduce it. This says so per
 * coin, with the USD value when known and a dash with the reason when not (never 0). Nothing is rendered for an empty list.
 */
export function PrehistoryCreditNote({ credits }: { credits: PrehistoryCredit[] }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  if (credits.length === 0) return null;
  return (
    <div className="stack" style={{ gap: 6 }} data-testid="prehistory-credit-note">
      <div className="notice" role="status" style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
        <div className="small" style={{ flex: 1 }}>
          Tartalmazza:{' '}
          {credits.map((c, i) => (
            <Fragment key={c.asset}>
              {i > 0 ? ' + ' : null}
              <b className="mono">{formatDecimal(c.quantity)} {c.asset}</b> (<Val value={c.value_usd} reason={c.value_reason} unit="USD" dp={0} />)
            </Fragment>
          ))}{' '}
          előzményként jelölt (rendszeren kívüli) visszafizetés nélkül — a könyvelés szerinti hitelszámla-egyenleg ennyivel kevesebb.
        </div>
        <HelpButton label="előzményként jelölt visszafizetés" open={open} onToggle={() => setOpen((o) => !o)} controls={id} />
      </div>
      {open ? <HelpText helpKey="prehistoryCredit" id={id} /> : null}
    </div>
  );
}
